import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { THEMES } from '@helpers/theme.config';

export enum ThemeType {
    Dark = 'dark',
    Light = 'light',
}

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    constructor(@Inject(DOCUMENT) private document: Document) {
        const saved = localStorage.getItem(this._storageKey) as ThemeType | null;
        this.setTheme(saved ?? ThemeType.Dark);
    }

    private readonly _storageKey = 'theme';

    get current(): 'light' | 'dark' {
        return (document.documentElement.getAttribute('data-theme') as 'dark' | null) ? 'dark' : 'light';
    }

    toggle(theme: ThemeType): void {
        this.setTheme(theme);
    }

    setTheme(theme = ThemeType.Dark): void {
        if (!THEMES[theme]) {
            theme = ThemeType.Dark;
        }
        Object.keys(theme).forEach(key => {
            this.document.documentElement.style.setProperty(`--${key}`, theme[key]);
        });

        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('dark-theme');
        if (theme === ThemeType.Dark) body.classList.add('dark-theme');
        // if (theme === ThemeType.Dark) {
        //     body.classList.add('dark-theme');
        //     document.documentElement.setAttribute('data-theme', 'dark');
        // } else {
        //     document.documentElement.removeAttribute('data-theme');
        // }

        localStorage.setItem(this._storageKey, theme);
    }
}
